import {useEffect} from 'react';

const useWindowEventListener = (type: string, listener: EventListenerOrEventListenerObject) => {
    useEffect(() => {
        window.addEventListener(type, listener);

        return () => window.removeEventListener(type, listener);
    }, []);
};

export default useWindowEventListener;
